/**
 * src/components/shared/HoursBadge.jsx — Unified Hours Display
 * AC Nautitech Design System
 *
 * Compact actual/planned hours badge used on task cards, project cards,
 * bundle bars, and analytics sections. Single source of truth for hours formatting.
 *
 * Formats:
 *   planned only:    "8h"
 *   actual/planned:  "2/8h"
 *   over budget:     "10/8h" (red)
 *   remaining:       "6h left"
 */

const HEALTH_COLORS = {
  healthy: 'var(--ok)',
  warning: 'var(--warn)',
  risk: 'var(--bad)',
  critical: 'var(--bad)',
};

const SIZE_MAP = {
  sm: { fontSize: 10, padding: '2px 6px', gap: 2 },
  md: { fontSize: 13, padding: '2px 8px', gap: 3 },
};

export default function HoursBadge({
  actual = 0,
  planned = 0,
  showRemaining = false,
  size = 'sm',
  health = 'healthy',
}) {
  if (!planned && !actual) return null;

  const isOverrun = actual > 0 && planned > 0 && actual > planned;
  const color = isOverrun ? 'var(--bad)' : (actual > 0 ? HEALTH_COLORS[health] || 'var(--accent)' : 'var(--accent)');
  const s = SIZE_MAP[size] || SIZE_MAP.sm;
  const remaining = Math.max(planned - actual, 0);

  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: s.gap,
        fontSize: s.fontSize,
        fontWeight: 600,
        color,
        padding: s.padding,
        borderRadius: 6,
        background: isOverrun ? 'rgba(229,62,62,0.1)' : 'var(--accent-bg, rgba(28,63,117,0.08))',
        whiteSpace: 'nowrap',
      }}
    >
      {showRemaining ? (
        <span>{remaining}h left</span>
      ) : actual > 0 ? (
        <span>{Math.round(actual)}/{planned}h</span>
      ) : (
        <span>{planned}h</span>
      )}
    </span>
  );
}
